import { queryOptions, useQuery, skipToken } from '@tanstack/react-query'
import { IAuthContext, useAuth } from './useAuth'
import { TilsynsobjektResponseV2, TilsynsobjektV2 } from '../types/types'
import { throwOnError } from '../utils/throwOnError'

export const getTilsynsobjekterOptions = (
  auth: IAuthContext,
  searchText?: string
) => {
  return queryOptions({
    enabled: searchText != null && searchText.length > 0,
    queryKey: ['tilsynsobjekt', searchText],
    queryFn: async () => {
      const { data, error } = await auth
        .authFetch()
        .GET('/tilsynsobjekt-api/v2/tilsynsobjekter', {
          params: {
            query: {
              search: searchText,
              identitetstypeIder: 'PRODUSENTNUMMER'
            }
          }
        })
      if (error) {
        throwOnError(error)
      }
      const response: TilsynsobjektResponseV2 =
        data as unknown as TilsynsobjektResponseV2
      return response.body?._embedded?.tilsynsobjektList ?? []
    }
  })
}

export const useGetTilsynsobjekterQuery = (searchText?: string) => {
  const auth = useAuth()
  return useQuery(getTilsynsobjekterOptions(auth, searchText))
}

export const useGetTilsynsobjektByIdQuery = (tilsynsobjektId?: string) => {
  const auth = useAuth()
  const authFetch = auth?.authFetch
  return useQuery<TilsynsobjektV2>({
    queryKey: ['tilsynsobjekt', tilsynsobjektId],
    queryFn:
      tilsynsobjektId != null && tilsynsobjektId.length > 0
        ? async () => {
            const { data, error } = await authFetch().GET(
              '/tilsynsobjekt-api/tilsynsobjekter/id/{id}',
              {
                params: {
                  path: {
                    id: tilsynsobjektId
                  }
                }
              }
            )
            if (error) {
              throwOnError(error)
            }
            return data as unknown as TilsynsobjektV2
          }
        : skipToken
  })
}
